var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCitiwork(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    width: 696,
    height: 696,
    viewBox: "0 0 696 696",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 696,
    height: 696,
    fill: "#ffffff",
    x: 0,
    y: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,48) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,48) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,72) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,72) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,72) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,72) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,72) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,72) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,96) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,96) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,96) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,96) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,96) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,96) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,96) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,120) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,120) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,120) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,120) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,120) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,144) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,144) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,144) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,144) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,144) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,168) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,168) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,168) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,168) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,168) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,168) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,168) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,192) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,192) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,192) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,192) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,192) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,216) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,216) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,216) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,216) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,216) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,240) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,264) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,288) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(216,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,312) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,336) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(216,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,360) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(216,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,384) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(168,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,408) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,432) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,456) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,480) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,504) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,504) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,504) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,504) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,504) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,504) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,504) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,528) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,552) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,552) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,552) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,552) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384,552) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,552) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,552) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,552) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,552) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,552) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,552) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,552) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,576) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,576) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,576) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,576) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,576) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,576) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,576) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,600) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,600) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336,600) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(408,600) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(432,600) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(456,600) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,600) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,600) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,600) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,600) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,624) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,624) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288,624) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,624) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,624) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(504,624) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,624) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(552,624) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(576,624) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,624) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,624) scale(4.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,48)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5,14h5.1C12,14,14,12,14,9.6V4.5C14,2,12,0,9.5,0H4.4C2,0,0,2,0,4.4v5.1C0,12,2,14,4.5,14z M12,4.8v4.4 c0,1.5-1.3,2.8-2.8,2.8H4.8C3.2,12,2,10.8,2,9.2V4.8C2,3.3,3.3,2,4.8,2h4.4C10.8,2,12,3.2,12,4.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,48)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5,14h5.1C12,14,14,12,14,9.6V4.5C14,2,12,0,9.5,0H4.4C2,0,0,2,0,4.4v5.1C0,12,2,14,4.5,14z M12,4.8v4.4 c0,1.5-1.3,2.8-2.8,2.8H4.8C3.2,12,2,10.8,2,9.2V4.8C2,3.3,3.3,2,4.8,2h4.4C10.8,2,12,3.2,12,4.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48,480)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5,14h5.1C12,14,14,12,14,9.6V4.5C14,2,12,0,9.5,0H4.4C2,0,0,2,0,4.4v5.1C0,12,2,14,4.5,14z M12,4.8v4.4 c0,1.5-1.3,2.8-2.8,2.8H4.8C3.2,12,2,10.8,2,9.2V4.8C2,3.3,3.3,2,4.8,2h4.4C10.8,2,12,3.2,12,4.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96,96)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,1.7v2.7C6,5.2,5.2,6,4.3,6H1.7C0.7,6,0,5.3,0,4.3V1.7C0,0.8,0.8,0,1.7,0h2.7C5.3,0,6,0.7,6,1.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(528,96)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,1.7v2.7C6,5.2,5.2,6,4.3,6H1.7C0.7,6,0,5.3,0,4.3V1.7C0,0.8,0.8,0,1.7,0h2.7C5.3,0,6,0.7,6,1.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(96,528)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,1.7v2.7C6,5.2,5.2,6,4.3,6H1.7C0.7,6,0,5.3,0,4.3V1.7C0,0.8,0.8,0,1.7,0h2.7C5.3,0,6,0.7,6,1.7z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCitiwork);
export default __webpack_public_path__ + "static/media/citiwork.e78b519bcbc836524da41dd24d50996a.svg";
export { ForwardRef as ReactComponent };